@use '../../scss/utility/functions' as utility;

:host {
  display: block;
  margin-block-start: utility.wb-pixel-to-rem(4px);
  color: var(--wb-grey-40);
}

:host([theme='dark']) {
  color: var(--wb-grey-70);
}
